import { render, staticRenderFns } from "./_base-modal-Backup.vue?vue&type=template&id=7f4603b0&scoped=true&"
import script from "./_base-modal-Backup.vue?vue&type=script&lang=js&"
export * from "./_base-modal-Backup.vue?vue&type=script&lang=js&"
import style0 from "./_base-modal-Backup.vue?vue&type=style&index=0&id=7f4603b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4603b0",
  null
  
)

export default component.exports